module.exports = __webpack_public_path__ + "assets/img/00091.e50b0534.png";